<div *ngIf="isAdmin">
  <mat-card-subtitle>
    <mat-checkbox labelPosition="after" (change)="onChangeAdminView($event)" fxLayoutAlign="end center" data-cy="form-demandes-listes-admin-view">
      Vue administrateur
    </mat-checkbox>
  </mat-card-subtitle>
</div>

<mat-card class="mat-elevation-z4">
  <mat-card-content>
      <mat-accordion>
        <!-- Recherche de demandes -->
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>Recherche de demandes</mat-panel-title>
            <mat-panel-description>sur les demandes des formulaires que vous gérez</mat-panel-description>
          </mat-expansion-panel-header>
          <app-search-demandes-results *ngIf="connecte" [connecte]="connecteSearch"></app-search-demandes-results>
        </mat-expansion-panel>
        <!-- Récap / décompte des demandes par formulaires -->
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Récapitulatif des demandes par formulaires
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
          <div fxLayoutAlign="end">
            <button mat-icon-button matTooltip="Rafraîchir la liste" (click)="refreshList()"><mat-icon>refresh</mat-icon></button>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="! loading">
            <app-responses-status-summary [listForms]="listForms" *ngIf="hasForms()"></app-responses-status-summary>
            <div *ngIf="! hasForms()">
              <span class="mat-body-strong">Aucun formulaire avec ses demandes trouvé sur ces critères</span>
            </div>
            <div fxLayoutGap="5px">
              <!-- filtre sur statut formulaire -->
              <mat-form-field>
                <mat-select placeholder="Filtrer sur un statut formulaire"
                            [compareWith]="compareFn"
                            [(ngModel)]="stateModel" (selectionChange)="onSelectState($event)" data-cy="select-form-demandes-list-state-filter">
                  <mat-option [value]="null" data-cy="option-formulaires-demandes-liste-all-state"><< Tout statut >></mat-option>
                  <mat-option *ngFor="let state of listStates" [value]="state" [attr.data-cy]="'option-formulaires-demandes-liste-'+state.id">
                    <span [ngStyle]="{'color': state?.color || 'initial'}">{{state.label}}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- filtre sur un formulaire -->
              <mat-form-field  *ngIf="hasForms()">
                <mat-select placeholder="Filtrer sur un formulaire" [(ngModel)]="formModel" (selectionChange)="onSelectFilter($event)" data-cy="select-form-demande-list-form-filter">
                  <mat-option [value]="null" data-cy="option-formulaires-demandes-liste-all-form"><< Tout formulaire >></mat-option>
                  <mat-option *ngFor="let form of listSelectForms" [value]="form" [attr.data-cy]="'option-formulaires-demandes-liste-'+form.uuid">
                    {{form.nom}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        <!-- liste du décompte demandes par formulaire -->
          <div *ngIf="! loading">
            <ul class="formulaire-list">
              <ng-container *ngFor="let form of listForms">
                <li class="formulaire-item flex align-start">
                    <div class="flex">
                      <div class="formulaire-logo">
                        <a routerLink="/gestion/responses/{{form.uuid}}"
                           style="text-decoration: none; color: #333333;"
                           matTooltip="ouvrir la vue des demandes de ce formulaire">
                          <mat-icon class="md-icon-2x" [attr.data-cy]="'icon-form-demandes-list-keyboard-'+form.uuid">keyboard_double_arrow_right</mat-icon>
                        </a>
                      </div>
                      <div class="formulaire-details">
                        <p class="formulaire-title"><span [innerHTML]="displayStateForm(form)"></span>&nbsp;
                          <span>
                            <a routerLink="/gestion/responses/{{form.uuid}}"
                               target="_blank"
                               matTooltip="ouvrir les demandes de ce formulaire dans une nouvelle fenêtre"
                               style="text-decoration: none; color: #333333;" [attr.data-cy]="'a-form-demandes-list-'+form.uuid">
                              {{form.nom}}</a>
                            <a href="" (click)="openModalLinkForm($event, form)"
                               matTooltip="obtenir le lien de partage du formulaire"
                               style="text-decoration: none; color: #333333;">
                              <mat-icon>link</mat-icon>
                            </a>
                            <a routerLink="/gestion/responses/{{form.uuid}}"
                               target="_blank"
                               matTooltip="ouvrir les demandes de ce formulaire dans une nouvelle fenête"
                               style="text-decoration: none; color: #333333;">
                              <mat-icon>open_in_new</mat-icon>
                            </a>
                          </span>

                        </p>
                        <ul class="formulaire-stats flex">
                          <li>
                            <app-bloc-response-status [form]="form" [state]="typeDemandes.En_attente"></app-bloc-response-status>
                          </li>
                          <li>
                            <app-bloc-response-status [form]="form" [state]="typeDemandes.En_traitement"></app-bloc-response-status>
                          </li>
                          <li>
                            <app-bloc-response-status [form]="form" [state]="typeDemandes.Incomplet"></app-bloc-response-status>
                          </li>
                          <li>
                            <app-bloc-response-status [form]="form" [state]="typeDemandes.Traitees"></app-bloc-response-status>
                          </li>
                          <li>
                            <app-bloc-response-status [form]="form" [state]="typeDemandes.Archivees"></app-bloc-response-status>
                          </li>
                        </ul>
                      </div>
                    </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
  </mat-card-content>
</mat-card>

